import PointRoutes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'equipment-disassemble-training',
  title: '设备拆解培训(5.0)',
  version: '0.1.5',
  description: '',
  routes: PointRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [],
  },
  config: {
    currentEnv: {},
  },
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
